/* raw layout hash: _anonymous-web-layout:23096f30d862454f7a045381e203dd63b4896d708d792e83a7285c68b3ee3fc9 */
import React from "react";
import AnonymousShell from "./AnonymousShell.jsx";

// Layout "_anonymous-web-layout" (RawHTMLDesign/layouts/_anonymous-web-layout.html)
export default function AnonymousWebLayout({ children }) {
  return <AnonymousShell>{children}</AnonymousShell>;
}
